module.exports = __webpack_public_path__ + "static/media/infographicsMoreLikeThis_mobile.b74f2623.svg";